const semanticClassNames = {
  container: 'dropzone__container',
  containerDragActive: 'dropzone__container--drag-active',
} as const;

export default semanticClassNames;
